import { IToolbarItem } from "./IToolbarItem";
import { Toolbar } from "../Toolbar";

export abstract class ToolbarItem implements IToolbarItem {
    public id: string = null;
    protected value: string = null;

    public constructor(protected control: HTMLElement, protected toolbar: Toolbar) {
        if (control.hasAttribute("data-value")) {
            this.value = control.getAttribute("data-value");
        }
        if (control.hasAttribute("data-id")) {
            this.id = control.getAttribute("data-id");
        }
    }

    public findItemById(id: string): IToolbarItem {
        if (id == this.id) {
            return this;
        }
        return null;
    }

    public enable(enable: boolean) {
        alert("Implementation error: Please override IToolbarItem.enable()");
    }
}
